export default __webpack_public_path__ + "static/media/astro.314ae079.svg";